'use strict';

var objectIterator = require('../utils/objectIterator');
var type = require('../value/type');

module.exports = function (item, condition) {
  var itemType = type(item);
  if (itemType === 'array' || itemType === 'string') {
    return Array.prototype.some.call(item, condition);
  }
  return objectIterator(item, 'some', condition);
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/any.js
// module id = 2179
// module chunks = 37